/* eslint-disable max-len */
import React from 'react';
//////////////////////////////////////////////////

const radio = (color, width, height) => (
  <svg
    viewBox='0 0 24 24'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M12 22a10 10 0 1 1 0-20 10 10 0 1 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-3a5 5 0 1 1 0-10 5 5 0 0 1 0 10z'
    />
  </svg>
);

const refresh = (color, width, height) => (
  <svg
    viewBox='0 0 18 20'
    width={width || 18}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M.058 10.7a6.71 6.71 0 0 1 .293-3.025C1.4 4.536 4.69 2.228 8.596 2.187V.135c0-.114.162-.175.269-.106l4.814 3.103c.08.053.08.158 0 .207L8.87 6.442c-.11.069-.269.008-.269-.106V4.288c-2.567.037-4.758 1.425-5.7 3.387-.358.741-.54 1.56-.488 2.419.07 1.18.576 2.267 1.374 3.147.427.468.325 1.152-.227 1.506-.525.338-1.259.244-1.662-.203C.907 13.46.249 12.142.058 10.7zm13.9-3.94c.803.875 1.309 1.966 1.374 3.146a4.91 4.91 0 0 1-.487 2.419c-.943 1.962-3.134 3.355-5.701 3.387v-2.048c0-.114-.163-.175-.27-.106L4.06 16.661c-.079.053-.079.159 0 .207l4.81 3.103c.111.069.269.008.269-.106v-2.052c3.904-.037 7.2-2.345 8.245-5.488a6.78 6.78 0 0 0 .292-3.025c-.185-1.442-.845-2.76-1.833-3.844a1.33 1.33 0 0 0-1.662-.203c-.548.354-.65 1.038-.223 1.506z'
    />
  </svg>
);

const reloadCircle = (color, width, height) => (
  <svg
    viewBox='0 0 17 15'
    width={width || 17}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#fff'}>
      <path d='M8.303 15c-3.286 0-6.211-2.052-7.279-5.106a.43.43 0 0 1 .273-.549.44.44 0 0 1 .559.269c.945 2.704 3.537 4.52 6.448 4.52 3.759 0 6.816-3.006 6.816-6.7 0-.24.198-.434.44-.434s.44.194.44.433C16 11.605 12.547 15 8.303 15zM1.44 8A.436.436 0 0 1 1 7.568C1 3.395 4.453 0 8.696 0c3.286 0 6.211 2.051 7.28 5.105a.432.432 0 0 1-.273.55.442.442 0 0 1-.56-.269C14.199 2.681 11.608.865 8.697.865 4.938.865 1.88 3.872 1.88 7.568A.435.435 0 0 1 1.44 8z' />
      <path d='M15.434 6a.412.412 0 0 1-.129-.022l-3.002-1.015c-.228-.077-.354-.339-.283-.585s.314-.383.541-.306l2.62.887.985-2.665c.088-.24.34-.357.561-.26a.48.48 0 0 1 .242.606l-1.134 3.066a.434.434 0 0 1-.4.294zM.432 13a.394.394 0 0 1-.16-.034.479.479 0 0 1-.241-.606l1.134-3.066c.083-.227.314-.346.53-.272l3.002 1.015c.228.076.354.338.283.584s-.314.383-.541.306l-2.62-.886-.985 2.665A.435.435 0 0 1 .432 13z' />
    </g>
  </svg>
);

const remove = (color, width, height) => (
  <svg
    viewBox='0 0 11 12'
    width={width || 11}
    height={height || 12}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#c8c8c8'}
      d='M.787 10.503A1.5 1.5 0 0 0 2.286 12H8.28a1.5 1.5 0 0 0 1.498-1.497V3.016H.788v7.487zM6.75.743V0h-3v.743H0V2.23h10.5V.743z'
    />
  </svg>
);

const renderActionsMenuIcon = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5zM3.75 9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zM7.5 9a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 7.5 9zm3.75 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z'
    />
  </svg>
);

const renderAddFileIcon = (color, width, height) => (
  <svg
    viewBox='0 0 14 16'
    width={width || 14}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      strokeWidth='.3'
      fill={color || '#707070'}
      stroke={color || '#707070'}
      d='M11.536 3.59L7.928.067A.243.243 0 0 0 7.76 0H.719C.336 0 0 .305 0 .68v13.156c0 .19.098.368.235.503a.785.785 0 0 0 .537.208h10.127a.73.73 0 0 0 .503-.198.68.68 0 0 0 .216-.478V3.751c0-.06-.039-.118-.082-.16zM7.687.48l3.226 3.157H7.679L7.687.481zm3.466 13.391c0 .058-.038.116-.08.157a.262.262 0 0 1-.174.065H.772a.32.32 0 0 1-.208-.075c-.05-.05-.1-.114-.1-.182V.68C.465.556.59.455.718.455h6.496l-.007 3.407a.23.23 0 0 0 .07.162.242.242 0 0 0 .168.067h3.709v9.78z'
    />
    <circle r='4.5' cx='9.5' cy='11.5' fill='#fff' />
    <path
      fill={color || '#707070'}
      d='M12.683 8.318A4.474 4.474 0 0 0 9.5 7a4.474 4.474 0 0 0-3.183 1.318 4.504 4.504 0 0 0 0 6.364A4.47 4.47 0 0 0 9.5 16a4.474 4.474 0 0 0 3.183-1.318 4.504 4.504 0 0 0 0-6.364zm-.578 5.785A3.66 3.66 0 0 1 9.5 15.182a3.66 3.66 0 0 1-2.605-1.079 3.685 3.685 0 0 1 0-5.206A3.66 3.66 0 0 1 9.5 7.818a3.66 3.66 0 0 1 2.605 1.079 3.685 3.685 0 0 1 0 5.206zm-.462-2.96H9.857V9.357a.357.357 0 0 0-.714 0v1.786H7.357a.357.357 0 0 0 0 .714h1.786v1.786a.357.357 0 0 0 .714 0v-1.786h1.786a.357.357 0 0 0 0-.714z'
    />
  </svg>
);

const renderAuditHistoryIcon = (color, width, height) => (
  <svg
    viewBox='0 0 21 20'
    width={width || 21}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='.9'
      fill={color || '#353535'}
      d='M11.025 0c-3.675 0-6.93 2-8.61 5.053L0 2.632v6.842h6.825l-2.94-2.948c1.365-2.631 3.99-4.42 7.14-4.42C15.33 2.105 18.9 5.683 18.9 10s-3.57 7.895-7.875 7.895c-3.465 0-6.3-2.21-7.455-5.263H1.365C2.52 16.842 6.405 20 11.025 20 16.59 20 21 15.474 21 10S16.485 0 11.025 0zM9.45 5.263v5.369l4.935 2.947.84-1.368-4.2-2.527v-4.42H9.45z'
    />
  </svg>
);

const renderCallCheckIcon = (color, width, height) => (
  <svg
    viewBox='0 0 12 15'
    width={width || 12}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M5.636 0A5.616 5.616 0 0 0 .02 5.616c0 3.101 4.68 9.36 5.616 9.36s5.616-6.259 5.616-9.36A5.616 5.616 0 0 0 5.636 0zm0 9.36a3.748 3.748 0 0 1-3.744-3.744 3.748 3.748 0 0 1 3.744-3.744A3.748 3.748 0 0 1 9.38 5.616 3.748 3.748 0 0 1 5.636 9.36zm2.252-2.405l-.772-.774a.402.402 0 0 0-.568.01l-.389.39-.077-.043a3.871 3.871 0 0 1-.935-.678c-.355-.355-.542-.693-.679-.94l-.041-.075.26-.26.129-.13a.404.404 0 0 0 .01-.569l-.772-.774a.402.402 0 0 0-.567.011l-.218.22a1.63 1.63 0 0 0-.173.322 1.31 1.31 0 0 0-.08.322c-.102.847.284 1.621 1.332 2.672 1.45 1.452 2.617 1.343 2.668 1.337a1.302 1.302 0 0 0 .636-.26l.226-.212a.405.405 0 0 0 .01-.57z'
    />
  </svg>
);

const renderCancelRecording = (
  color,
  width,
  height,
  bgColor,
  strokeColor,
) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 40}
    height={height || 40}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={bgColor || '#ce2828'}>
      <circle
        cx='20'
        cy='20'
        r='17.5'
        strokeWidth='5'
        strokeOpacity='.3'
        stroke={strokeColor || '#fff'}
      />
      <path
        fill={color || '#fff'}
        d='M21.699 20.279l4.435-4.436a1.045 1.045 0 1 0-1.478-1.478L20.22 18.8l-4.435-4.435a1.045 1.045 0 1 0-1.479 1.478l4.436 4.436-4.436 4.435a1.046 1.046 0 0 0 1.479 1.479l4.435-4.436 4.436 4.436a1.045 1.045 0 1 0 1.478-1.479L21.7 20.28z'
      />
    </g>
  </svg>
);

const renderChatIcon = (color, width, height) => (
  <svg
    viewBox='0 0 17 15'
    width={width || 17}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#707070'}
      d='M10.025 10.184c1.027-.485 1.837-1.146 2.431-1.982s.891-1.746.891-2.731-.297-1.895-.89-2.731-1.405-1.497-2.432-1.982A7.75 7.75 0 0 0 6.674.03a7.75 7.75 0 0 0-3.351.728C2.296 1.243 1.485 1.904.89 2.74S0 4.486 0 5.47a4.54 4.54 0 0 0 .673 2.382c.449.743 1.065 1.37 1.849 1.88l-.194.468a2.75 2.75 0 0 1-.238.41l-.213.307a4.09 4.09 0 0 1-.246.314 7.248 7.248 0 0 0-.218.265c0-.007-.013.01-.038.048s-.04.057-.043.053-.016.014-.038.053l-.033.059-.024.053a.247.247 0 0 0-.019.063.465.465 0 0 0-.005.07c0 .024.004.047.01.068a.365.365 0 0 0 .109.224.28.28 0 0 0 .194.084h.029l.815-.17a7.606 7.606 0 0 0 2.635-1.36c.57.114 1.125.17 1.669.17 1.207 0 2.324-.242 3.35-.727zm6.289.393a4.52 4.52 0 0 0 .674-2.386 4.53 4.53 0 0 0-.711-2.444c-.475-.758-1.12-1.389-1.934-1.892a6.1 6.1 0 0 1 .217 1.616c0 .949-.21 1.849-.635 2.699s-1.03 1.6-1.82 2.253a8.06 8.06 0 0 1-2.502 1.37 9.018 9.018 0 0 1-2.93.479 12.02 12.02 0 0 1-.834-.043c1.27.935 2.762 1.403 4.475 1.403.543 0 1.1-.057 1.668-.17a7.607 7.607 0 0 0 2.635 1.36 7.28 7.28 0 0 0 .816.17.266.266 0 0 0 .208-.074.404.404 0 0 0 .124-.234c-.003-.042 0-.066.009-.069s.008-.026-.005-.069a12.048 12.048 0 0 0-.019-.064l-.023-.053a.521.521 0 0 0-.071-.111 1.306 1.306 0 0 1-.043-.053 7.173 7.173 0 0 0-.256-.313 4.101 4.101 0 0 1-.246-.314l-.213-.308a2.743 2.743 0 0 1-.238-.41 6.205 6.205 0 0 1-.194-.467 5.84 5.84 0 0 0 1.848-1.876z'
    />
  </svg>
);

const renderCirclesIcon = (color) => (
  <svg
    width={4}
    height={18}
    viewBox='0 0 4 18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#338cbd'}>
      <circle cx='2' cy='2' r='2' />
      <circle cx='2' cy='9' r='2' />
      <circle cx='2' cy='16' r='2' />
    </g>
  </svg>
);

const renderClipIcon = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#707070'}
      d='M12.017 1.387a3.412 3.412 0 0 0-4.75 0L.738 7.772a2.424 2.424 0 0 0 0 3.482c.812.793 2.035.921 2.991.407a.42.42 0 0 0 .275-.116l6.53-6.384a1.616 1.616 0 0 0 0-2.322 1.706 1.706 0 0 0-2.375 0L2.816 8.063a.404.404 0 0 0 0 .58c.163.16.43.16.593 0L8.752 3.42a.852.852 0 0 1 1.187 0c.328.32.328.84 0 1.16l-6.233 6.095a1.706 1.706 0 0 1-2.375 0 1.616 1.616 0 0 1 0-2.321l6.53-6.387a2.559 2.559 0 0 1 3.562 0c.984.962.984 2.521 0 3.483l-5.936 5.804a.404.404 0 0 0 0 .58c.164.16.43.16.593 0l5.937-5.803a3.232 3.232 0 0 0 0-4.644z'
    />
    <circle r='4.5' cx='10.5' cy='10.5' fill='#fff' />
    <path
      fill={color || '#707070'}
      d='M13.683 7.318A4.474 4.474 0 0 0 10.5 6a4.474 4.474 0 0 0-3.183 1.318 4.504 4.504 0 0 0 0 6.364A4.47 4.47 0 0 0 10.5 15a4.474 4.474 0 0 0 3.183-1.318 4.504 4.504 0 0 0 0-6.364zm-.578 5.785a3.66 3.66 0 0 1-2.605 1.079 3.66 3.66 0 0 1-2.605-1.079 3.685 3.685 0 0 1 0-5.206A3.66 3.66 0 0 1 10.5 6.818a3.66 3.66 0 0 1 2.605 1.079 3.685 3.685 0 0 1 0 5.206zm-.462-2.96h-1.786V8.357a.357.357 0 0 0-.714 0v1.786H8.357a.357.357 0 0 0 0 .714h1.786v1.786a.357.357 0 0 0 .714 0v-1.786h1.786a.357.357 0 0 0 0-.714z'
    />
  </svg>
);

const renderColdIcon = (color, width, height) => (
  <svg
    viewBox='0 0 14 16'
    width={width || 14}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#2073a1'}
      d='M13.733 11.33l-1.727-1 1.458-.868c.234-.113.307-.428.173-.66s-.428-.286-.65-.157l-1.944 1.14-3.088-1.799 3.088-1.78 1.944 1.137a.38.38 0 0 0 .225.07.526.526 0 0 0 .425-.225c.13-.235.061-.546-.173-.66l-1.458-.868 1.727-.998a.488.488 0 0 0 .173-.66.479.479 0 0 0-.659-.174l-1.735 1.008-.026-1.737a.48.48 0 0 0-.477-.486.487.487 0 0 0-.477.486l.017 2.292-3.071 1.78V3.56l1.934-1.104a.49.49 0 0 0 .191-.66.466.466 0 0 0-.65-.174l-1.475.834V.486A.485.485 0 0 0 6.992 0a.477.477 0 0 0-.477.485v1.99l-1.527-.853a.461.461 0 0 0-.642.174.478.478 0 0 0 .182.66l1.987 1.12v3.577L3.374 5.34l.017-2.241c.027-.252-.2-.486-.468-.486h-.017a.49.49 0 0 0-.478.486l-.017 1.685-1.692-.972a.467.467 0 0 0-.65.172.48.48 0 0 0 .173.661l1.71.989-1.493.895c-.234.113-.307.427-.165.659.092.15.226.226.408.226a.468.468 0 0 0 .251-.07L2.906 6.19l3.132 1.796-3.132 1.815L.953 8.645c-.234-.137-.536-.072-.659.158a.488.488 0 0 0 .165.66l1.492.884-1.709.999a.476.476 0 0 0-.173.661.44.44 0 0 0 .407.243.87.87 0 0 0 .243-.07l1.692-.973.017 1.685a.482.482 0 0 0 .478.476h.017c.269 0 .47-.224.468-.494l-.017-2.24 3.14-1.796v3.558l-1.986 1.12a.474.474 0 0 0-.182.66c.096.165.225.244.407.244a.464.464 0 0 0 .235-.054l1.527-.866v2.022a.47.47 0 0 0 .477.478.48.48 0 0 0 .486-.478v-1.989l1.474.833a.453.453 0 0 0 .226.054.45.45 0 0 0 .425-.244.482.482 0 0 0-.19-.66l-1.935-1.085V8.82l3.07 1.78-.016 2.274a.483.483 0 0 0 .477.494.472.472 0 0 0 .477-.476l.026-1.746 1.735 1.017a.509.509 0 0 0 .252.051.447.447 0 0 0 .407-.226.478.478 0 0 0-.173-.659z'
    />
  </svg>
);

const renderDetailInfoIcon = (color, width, height) => (
  <svg
    viewBox='0 0 22 20'
    width={width || 22}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M13.89 16.529c-3.023 0-5.593-1.939-6.496-4.618H3.757v-1.319h3.339a6.655 6.655 0 0 1 .036-1.847H3.757V7.426h3.731a6.703 6.703 0 0 1 1.08-1.847H3.756V4.26h6.257a6.877 6.877 0 0 1 3.876-1.188 6.91 6.91 0 0 1 2.479.459V.169H0v16.888c0 1.451 1.208 2.639 2.684 2.639h11.002c1.476 0 2.683-1.188 2.683-2.64v-.986a6.906 6.906 0 0 1-2.479.459zm4.577-3.729a5.32 5.32 0 0 0 .924-3c0-2.987-2.463-5.409-5.502-5.409s-5.5 2.422-5.5 5.409 2.461 5.41 5.5 5.41c1.231 0 2.364-.403 3.28-1.074l3.366 3.31 1.328-1.306-3.396-3.34zm-4.577 1.09c-2.294 0-4.16-1.834-4.16-4.09s1.866-4.09 4.16-4.09 4.16 1.835 4.16 4.09-1.866 4.09-4.16 4.09z'
    />
  </svg>
);

const renderDownArrowIcon = (
  color,
  width,
  height,
  bgColor,
  stroke,
) => (
  <svg
    viewBox='0 0 18 18'
    width={width || 18}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='8'
      cx='9'
      cy='9'
      stroke={stroke}
      fill={bgColor || '#d8d8d8'}
    />
    <path
      fill={color || '#353535'}
      d='M6.126 9.787L8.47 12.77c.088.125.232.197.385.193.16 0 .289-.065.385-.16l2.632-2.985c.192-.225.16-.546-.032-.706-.225-.193-.546-.16-.706.032L9.4 11.102V6.513c.002-.137-.052-.268-.149-.365s-.228-.15-.365-.148-.268.052-.365.148-.15.228-.148.365v4.493L6.897 9.177a.5.5 0 0 0-.385-.193.62.62 0 0 0-.321.097c-.225.192-.257.513-.065.706z'
    />
  </svg>
);

const renderDownArrowIconBig = (
  color,
  width,
  height,
  bgColor,
  stroke,
) => (
  <svg
    viewBox='0 0 32 32'
    width={width || 32}
    height={height || 32}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='15'
      cx='16'
      cy='16'
      fill={bgColor || '#fff'}
      stroke={stroke || '#353535'}
    />
    <path
      fill={color || '#930000'}
      d='M10.612 17.475l4.392 5.596a.86.86 0 0 0 .722.36 1 1 0 0 0 .723-.3l4.933-5.596c.361-.421.301-1.023-.06-1.324-.42-.36-1.023-.3-1.323.06l-3.25 3.671v-8.604a.95.95 0 0 0-.962-.963.95.95 0 0 0-.963.963v8.423l-2.768-3.43a.94.94 0 0 0-.722-.36c-.18 0-.421.06-.602.18-.42.361-.481.963-.12 1.324z'
    />
  </svg>
);

const renderDownArrowSimpleIcon = (color) => (
  <svg
    width={12}
    height={14}
    viewBox='0 0 12 14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#2073a1'}
      d='M.612 7.475l4.392 5.596a.86.86 0 0 0 .722.36 1 1 0 0 0 .723-.3l4.933-5.596c.361-.421.301-1.023-.06-1.324-.42-.36-1.023-.3-1.323.06l-3.25 3.671V1.338a.95.95 0 0 0-.962-.963.95.95 0 0 0-.963.963V9.76L2.056 6.33a.94.94 0 0 0-.722-.36c-.18 0-.421.06-.602.18-.42.361-.481.963-.12 1.324z'
    />
  </svg>
);

const renderDownArrowWithSettingIcon = (
  color,
  width,
  height,
  bgColor,
  stroke,
  subColor,
) => (
  <svg
    viewBox='0 0 18 17'
    width={width || 18}
    height={height || 17}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#d8d8d8'}>
      <circle
        r='8'
        cx='8'
        cy='8'
        stroke={stroke}
        fill={bgColor || '#d8d8d8'}
      />
      <circle
        cx='14'
        cy='13'
        r='1.333'
        fill={bgColor || '#d8d8d8'}
      />
    </g>
    <path
      fill={subColor || '#ce2828'}
      d='M16.899 14.02c.018-.05.077-.092.105-.092h.369a.628.628 0 0 0 .627-.627v-.602a.628.628 0 0 0-.627-.627h-.369c-.028 0-.087-.042-.105-.093a3.044 3.044 0 0 0-.13-.308c-.022-.047-.01-.118.01-.137l.262-.262a.628.628 0 0 0 0-.888l-.425-.425a.623.623 0 0 0-.888 0l-.262.262c-.008.008-.036.021-.076.021a.145.145 0 0 1-.061-.012 3.045 3.045 0 0 0-.308-.129c-.05-.017-.093-.077-.093-.105v-.369A.628.628 0 0 0 14.301 9h-.602a.628.628 0 0 0-.627.627v.369c0 .028-.042.087-.092.105-.105.037-.209.08-.309.13a.146.146 0 0 1-.06.011c-.041 0-.07-.013-.077-.02l-.262-.263a.623.623 0 0 0-.887 0l-.426.425a.628.628 0 0 0 0 .888l.262.262c.02.02.032.09.01.137-.05.1-.093.204-.13.309-.018.05-.077.092-.105.092h-.369a.628.628 0 0 0-.627.627v.602a.63.63 0 0 0 .627.627h.369c.028 0 .087.042.105.093.037.104.08.208.13.308.022.047.01.118-.01.137l-.262.262a.623.623 0 0 0 0 .888l.425.425a.623.623 0 0 0 .888 0l.262-.262c.008-.008.036-.021.076-.021.023 0 .045.004.061.012.1.048.204.092.309.129.05.017.092.077.092.105v.369a.63.63 0 0 0 .627.627h.602a.628.628 0 0 0 .627-.627v-.369c0-.028.042-.087.092-.105a2.77 2.77 0 0 0 .309-.13.145.145 0 0 1 .06-.011c.041 0 .07.013.077.02l.262.263a.623.623 0 0 0 .888 0l.425-.425a.628.628 0 0 0 0-.888l-.262-.261c-.02-.02-.032-.09-.01-.138.05-.1.093-.204.13-.309zM15.222 13c0 .674-.548 1.222-1.222 1.222A1.224 1.224 0 0 1 12.778 13c0-.674.548-1.222 1.222-1.222s1.222.548 1.222 1.222z'
    />
    <path
      fill={color || '#353535'}
      d='M5.126 8.787L7.47 11.77a.457.457 0 0 0 .385.193c.16 0 .289-.065.385-.16l2.632-2.985c.192-.225.16-.546-.032-.706-.225-.193-.546-.16-.706.032L8.4 10.102V5.513A.507.507 0 0 0 7.886 5a.507.507 0 0 0-.513.513v4.493L5.897 8.177a.502.502 0 0 0-.385-.193.62.62 0 0 0-.321.097c-.225.192-.257.513-.065.706z'
    />
  </svg>
);

const renderDrayageIcon = (color, width, height) => (
  <svg
    viewBox='0 0 30 15'
    width={width || 30}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#d8d8d8'}>
      <use href='#A' x='.131' y='-.022' />
      <use href='#A' x='-14.006' transform='matrix(1 0 0 -1 .065312 26.004384)' />
      <use href='#A' x='-18.636' />
      <path d='M5.044 10.673c.22.267.396.61.502 1a2.65 2.65 0 0 1 .498-1zm-4.598 0a.4.4 0 0 0-.402.396v1.207a.4.4 0 0 0 .4.397h.41c-.008-1 .42-1.499 1.189-2zm18.563-9c-.331 0-.596.277-.596.617v8.826h-8.369a2.563 2.563 0 0 1 .828 1.557h8.617c.173-1.225 1.411-2.273 2.643-2.273s2.309 1.048 2.482 2.273l4.797.057c.164 0 .299-.139.299-.309v-.937-.002c0-.17-.135-.309-.299-.309h-.723V6.98a2.53 2.53 0 0 0-.408-1.379l-2.752-2.668c-.444-.679-1.914-1.26-2.707-1.26zm1.52 2h3.674a.58.58 0 0 1 .396.141l2.357 2.33c.224.223-.004.529-.396.529h-6.031c-.267 0-.485-.149-.485-.338V4.011c0-.186.218-.338.484-.338z' />
      <path d='M1.597.195a.89.89 0 0 0-.893.887v8.816c0 .164.133.297.297.297h15.406c.164 0 .297-.133.297-.297V1.082a.89.89 0 0 0-.893-.887zm1.6 1h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm2 0h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm3 0h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm2 0h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm3 0h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm2 0h.016c.272 0 .492.116.492.26v7.48c0 .144-.22.26-.492.26h-.016c-.272 0-.492-.116-.492-.26v-7.48c0-.144.22-.26.492-.26zm14.174 10.809v.002z' />
    </g>
    <defs>
      <path id='A' d='M22.005 11c-1.776 0-2.667 2.152-1.412 3.413s3.403.372 3.407-1.409v-.002c-.001-1.105-.895-2.001-1.995-2.002zm-.22 1.025a1 1 0 0 1 1.218.975c-.001 1.332-1.994 1.33-1.993-.002a1 1 0 0 1 .775-.973z' />
    </defs>
  </svg>
);

const driverIcon = (color, subColor) => (
  <g
    fillRule='evenodd'
    fill={(color || '#707070')}
  >
    <path
      fill={(color || '#707070')}
      d='M.12 14.573h2.417c.284-2.639 1.662-3.972 4.134-3.998 2.471-.026 3.948 1.307 4.429 3.998h2.319c-.597-2.76-1.133-4.459-1.608-5.099-.474-.64-1.53-1.214-3.17-1.722L6.77 9.608 4.874 7.752c-1.465.379-2.563.953-3.296 1.722-.732.77-1.218 2.47-1.458 5.1z' />
    <path
      strokeWidth='.7'
      stroke={color || '#707070'}
      d='M3.562 14.433h6.68c-.51-2.024-1.685-3.048-3.527-3.074-1.842-.025-2.893 1-3.153 3.074zM6.883 14.36L9.1 12.504M6.783 14.345v-2.984M6.804 14.347l-2.524-1.66' />
    <path
      fill={(color || '#707070')}
      d='M6.684 7.534c2.622.02 4.708-7.025.195-7.04-4.513-.016-2.816 7.021-.195 7.04z' />
    <path
      fill={subColor || '#cacaca'}
      d='M10.47 8.065l-2.763 2.863 1.033.445 2.756-2.937z' />
  </g>
);

const renderDriverIcon = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 14 15'
    width={width || 14}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    {driverIcon(color, subColor)}
  </svg>
);

const renderTeamDriverIcon = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 20 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>{driverIcon(color, subColor)}</g>
    <g transform='translate(6, 2)'>{driverIcon(color, subColor)}</g>
  </svg>
);

const renderEditIcon = (color, width, height) => (
  <svg
    viewBox='0 0 16 15'
    width={width || 16}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#707070'}
      d='M14.008.97a3.303 3.303 0 0 0-4.675 0L.76 9.54a.429.429 0 0 0-.122.245L.004 14.49a.427.427 0 0 0 .121.361c.08.08.192.128.304.128.019 0 .038 0 .057-.003l2.834-.383a.431.431 0 1 0-.115-.856l-2.272.307.444-3.281 3.453 3.453a.423.423 0 0 0 .606 0l8.572-8.57a3.28 3.28 0 0 0 .97-2.339 3.27 3.27 0 0 0-.97-2.336zm-4.51 1.053l1.44 1.44-7.822 7.822-1.44-1.44L9.5 2.024zm-4.362 11.28L3.73 11.894l7.822-7.823 1.407 1.408-7.822 7.822zm8.422-8.44L10.115 1.42a2.44 2.44 0 0 1 4.002 1.886 2.43 2.43 0 0 1-.559 1.558z'
    />
  </svg>
);

const renderEventIcon = (color, w, h, bgColor) => (
  <svg
    width={w || 20}
    height={h || 20}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='10'
      cx='10'
      cy='10'
      fill={bgColor || '#00C853'}
    />
    <path
      fill={color || '#00C853'}
      d='M4.682 11.038l.558.605c.193.199.42.298.677.298a.88.88 0 0 0 .67-.298l2.187-2.37v5.675c0 .28.095.521.283.726a.882.882 0 0 0 .67.306h.953a.882.882 0 0 0 .67-.306c.188-.205.282-.446.282-.726V9.273l2.188 2.37a.877.877 0 0 0 .67.298.92.92 0 0 0 .677-.298l.55-.605a1.04 1.04 0 0 0 .283-.733.998.998 0 0 0-.283-.726l-4.844-5.256a.877.877 0 0 0-.67-.298.92.92 0 0 0-.677.298L4.682 9.58a1.03 1.03 0 0 0-.275.726c0 .28.091.524.275.733z'
    />
  </svg>
);

const renderFileIcon = (color, width, height, fillOpacity) => (
  <svg
    viewBox='0 0 15 18'
    width={width || 15}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      fill={color || '#707070'}
      fillOpacity={fillOpacity || 1}
    >
      <path
        strokeWidth='.3'
        stroke={color || '#707070'}
        d='M14.18 8.199l-1.722-3.992a.2.2 0 0 0-.111-.105L6.81 1.977a.61.61 0 0 0-.78.343L1.87 13.157a.651.651 0 0 0 .382.82l7.962 3.055a.612.612 0 0 0 .78-.34l3.199-8.336c.019-.05.007-.11-.014-.157zm-2.042-3.723l1.538 3.573-2.543-.976 1.005-2.597zm-1.51 12.076a.215.215 0 0 1-.27.106l-7.961-3.056a.262.262 0 0 1-.14-.125c-.024-.055-.042-.123-.02-.18l4.16-10.836c.039-.103.17-.148.27-.11l5.106 1.96-1.083 2.805a.205.205 0 0 0 .004.154c.02.05.062.088.11.107l2.917 1.12-3.093 8.055z'
      />
      <path d='M9.183 5.138c0-.06-.03-.114-.078-.146a3.91 3.91 0 0 0-1.408-.571 4.21 4.21 0 0 0-1.7.019L3.916 1.756A2.014 2.014 0 0 0 3.832.331a.171.171 0 0 0-.11-.088.175.175 0 0 0-.138.025L.497 2.414a.179.179 0 0 0-.075.123c-.007.05.007.1.039.139.31.371.746.522 1.058.582l.176.027 1.641 3.011c-.221.359-.94 1.667-.67 3.171a.173.173 0 0 0 .136.14.17.17 0 0 0 .129-.028L5.88 7.53l1.831 2.8a.169.169 0 0 0 .239.046.18.18 0 0 0 .047-.245l-1.831-2.8 2.94-2.043a.18.18 0 0 0 .077-.15z' />
    </g>
  </svg>
);

const renderHazardousIcon = (color, width, height) => (
  <svg
    viewBox='0 0 16 16'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='8'
      cx='8'
      cy='8'
      fill={color || '#353535'}
    />
    <path fill='#fbe226' d='M8.84 9.612c.544-.314.85-.88.857-1.466l4.997-.073a6.649 6.649 0 0 0-.897-3.245 6.658 6.658 0 0 0-2.62-2.542l-2.35 4.352a1.716 1.716 0 0 0-1.702.007l-.005.003-2.466-4.267a6.682 6.682 0 0 0-3.347 5.887l4.961-.072A1.703 1.703 0 0 0 7.2 9.653l-2.377 4.403a6.696 6.696 0 0 0 6.524-.095L8.835 9.615l.005-.003zm-.358-.619a.997.997 0 1 1-1-1.728.997.997 0 1 1 1 1.728z' />
  </svg>
);

const renderHighSecurityIcon = (color, width, height) => (
  <svg
    viewBox='2 2 20 20'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#ff1744'}
      d='M6.2 3.5h11.6L22 9 12 21.5 2 9l4.2-5.5z'
    />
    <path
      fill='none'
      stroke='#fff'
      strokeWidth='.8'
      strokeOpacity='.68'
      strokeLinejoin='round'
      d='M2.5 9h19M6.2 3.8L9.3 9 12 21M17.8 3.8L14.7 9 12 21M6.2 3.8h11.6'
    />
  </svg>
);

const renderHotIcon = (color, width, height) => (
  <svg
    viewBox='0 0 16 16'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#ce2828'}
      d='M8 3.904A4.1 4.1 0 0 0 3.904 8 4.1 4.1 0 0 0 8 12.096 4.1 4.1 0 0 0 12.096 8 4.1 4.1 0 0 0 8 3.904zm-.832-.838h1.664a.366.366 0 0 0 .31-.15.366.366 0 0 0 .028-.344L8.255.216C8.182.028 8.064 0 8 0s-.182.028-.255.216L6.83 2.572a.366.366 0 0 0 .028.343c.066.096.179.151.31.151zm1.664 9.868H7.168a.366.366 0 0 0-.31.15.366.366 0 0 0-.028.344l.915 2.356c.073.188.191.216.255.216s.182-.028.255-.216l.915-2.356a.366.366 0 0 0-.028-.343.366.366 0 0 0-.31-.151zM3.334 4.989c.063.143.184.229.323.229a.38.38 0 0 0 .266-.119L5.1 3.923a.366.366 0 0 0 .113-.326.366.366 0 0 0-.223-.263L2.676 2.316a.41.41 0 0 0-.163-.04.23.23 0 0 0-.198.102c-.036.055-.064.15 0 .298l1.02 2.313zm9.332 6.022c-.063-.143-.184-.228-.323-.228a.38.38 0 0 0-.266.118L10.9 12.077a.366.366 0 0 0-.113.326c.021.114.103.21.223.263l2.313 1.019a.41.41 0 0 0 .163.038.23.23 0 0 0 .198-.101c.036-.055.064-.15 0-.298l-1.02-2.313zM12.077 5.1a.38.38 0 0 0 .266.118c.139 0 .26-.086.323-.23l1.019-2.312c.065-.147.036-.243 0-.298a.23.23 0 0 0-.198-.101.41.41 0 0 0-.163.039l-2.313 1.018a.366.366 0 0 0-.223.263.366.366 0 0 0 .113.326L12.077 5.1zm-8.154 5.8a.38.38 0 0 0-.266-.117c-.139 0-.26.085-.323.228l-1.018 2.313c-.065.148-.037.243-.001.298a.23.23 0 0 0 .198.101.41.41 0 0 0 .163-.039l2.313-1.018a.366.366 0 0 0 .223-.263.366.366 0 0 0-.113-.326L3.923 10.9zm11.861-3.155l-2.356-.915a.419.419 0 0 0-.151-.03c-.199 0-.343.155-.343.369v1.663c0 .213.144.368.343.368a.41.41 0 0 0 .151-.03l2.356-.915C15.972 8.182 16 8.064 16 8s-.028-.182-.216-.255zM2.723 9.2c.199 0 .343-.155.343-.368V7.168c0-.213-.144-.368-.343-.368a.41.41 0 0 0-.151.03l-2.356.915C.028 7.818 0 7.936 0 8s.028.182.216.255l2.356.915c.05.02.101.03.151.03z'
    />
  </svg>
);

const renderInfoAlertIcon = (color, width, height, bgColor, stroke) => (
  <svg
    viewBox='0 0 17 17'
    width={width || 17}
    height={height || 17}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='8'
      cx='8.5'
      cy='8.5'
      fill={bgColor || '#efd302'}
      stroke={stroke || '#707070'}
    />
    <path
      fill={color || '#707070'}
      d='M8.5 11c.465 0 .851-.295.89-.678l.605-5.976c.035-.346-.107-.689-.391-.945A1.657 1.657 0 0 0 8.5 3a1.66 1.66 0 0 0-1.104.401c-.284.256-.426.599-.39.945l.603 5.976c.04.383.426.678.891.678zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'
    />
  </svg>
);

const renderItemIconSmall = (color, width, height) => (
  <svg
    viewBox='0 0 11 10'
    width={width || 11}
    height={height || 10}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M9.969 0h-8.25a.35.35 0 0 0-.344.357v5.714a.35.35 0 0 0 .344.358h8.25a.35.35 0 0 0 .344-.358V.357A.35.35 0 0 0 9.969 0zm-.344 5.714H2.062v-5h7.563v5z' />
      <path d='M3.094 2.143H8.25a.35.35 0 0 0 .344-.357.35.35 0 0 0-.344-.357H3.094a.35.35 0 0 0-.344.357.35.35 0 0 0 .344.357zm0 1.428h3.781a.35.35 0 0 0 .344-.357.35.35 0 0 0-.344-.357H3.094a.35.35 0 0 0-.344.357.35.35 0 0 0 .344.357zM10.656 10H9.625a.339.339 0 0 1-.344-.333V9H6.36v.667a.339.339 0 0 1-.343.333H4.984a.339.339 0 0 1-.343-.333V9H1.719v.667a.339.339 0 0 1-.344.333H.344A.339.339 0 0 1 0 9.667v-2a.34.34 0 0 1 .344-.334h10.312a.34.34 0 0 1 .344.334v2a.339.339 0 0 1-.344.333zm-.687-.667h.344V8H.687v1.333h.344v-.666a.34.34 0 0 1 .344-.334h3.61c.19 0 .343.15.343.334v.666h.344v-.666a.34.34 0 0 1 .344-.334h3.609a.34.34 0 0 1 .344.334v.666z' />
    </g>
  </svg>
);

const renderMailIcon = (color, width, height) => (
  <svg
    viewBox='0 0 16 11'
    width={width || 16}
    height={height || 11}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M15.518.957L10.91 5.739l4.61 4.783a1.43 1.43 0 0 0 .133-.598v-8.37a1.41 1.41 0 0 0-.134-.597zM14.582 0H1.544A1.36 1.36 0 0 0 .95.14l6.13 6.146a1.384 1.384 0 0 0 1.966 0L15.178.14a1.366 1.366 0 0 0-.596-.14zM.134.957A1.43 1.43 0 0 0 0 1.554v8.37a1.42 1.42 0 0 0 .134.598l4.61-4.783L.133.957zm10.246 5.26l-.678.662c-.904.88-2.374.88-3.277 0l-.679-.662L.95 10.864a1.39 1.39 0 0 0 .595.136h13.038c.214 0 .415-.051.596-.136L10.38 6.217z'
    />
  </svg>
);

const renderPauseRecording = (
  color,
  width,
  height,
  bgColor,
  strokeColor,
) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 40}
    height={height || 40}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#fff'}>
      <circle
        cx='20'
        cy='20'
        r='17.5'
        strokeWidth='5'
        strokeOpacity='.3'
        stroke={strokeColor || '#fff'}
      />
      <path
        fill={bgColor || '#edb420'}
        d='M20 5C11.716 5 5 11.716 5 20s6.716 15 15 15 15-6.716 15-15S28.285 5 20 5zm-1.56 19.454a1.72 1.72 0 0 1-3.439 0v-8.908a1.72 1.72 0 0 1 3.44 0v8.908zm6.455 0a1.72 1.72 0 0 1-3.44 0v-8.908a1.72 1.72 0 0 1 3.44 0v8.908z'
      />
    </g>
  </svg>
);

const renderPickDropWithPlusIcon = (color, width, height) => (
  <svg
    viewBox='0 0 17 17'
    width={width || 17}
    height={height || 17}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='7.111'
      cx='8.111'
      cy='8.111'
      fill='#f3f3f3'
      stroke={color || '#930000'}
    />
    <path
      fill={color || '#930000'}
      d='M11.665 5.268L9.583 2.616c-.078-.111-.206-.175-.342-.172a.47.47 0 0 0-.343.143L6.56 5.24c-.17.2-.142.485.029.627.2.172.485.143.628-.028l1.54-1.74v4.079a.45.45 0 0 0 .456.456.45.45 0 0 0 .457-.456V4.184l1.31 1.626c.082.106.208.169.342.172a.55.55 0 0 0 .285-.086c.2-.171.229-.456.057-.628zM2.557 9.81l2.082 2.653c.086.114.2.171.342.171a.47.47 0 0 0 .343-.142l2.339-2.653c.17-.2.142-.485-.029-.628-.2-.17-.485-.142-.627.029l-1.54 1.74V6.9a.45.45 0 0 0-.457-.456.45.45 0 0 0-.456.457v3.993L3.24 9.268c-.083-.105-.208-.167-.342-.17a.55.55 0 0 0-.285.085c-.2.171-.228.456-.057.627z'
    />
    <circle r='4' cx='13' cy='13' fill='#f3f3f3' />
    <path
      fill={color || '#930000'}
      d='M15.828 10.172A3.97 3.97 0 0 0 13 9a3.97 3.97 0 0 0-2.828 1.172c-1.559 1.563-1.559 4.093 0 5.656A3.97 3.97 0 0 0 13 17a3.97 3.97 0 0 0 2.828-1.172c1.559-1.563 1.559-4.093 0-5.656zm-.514 5.142a3.25 3.25 0 0 1-2.314.959c-.874 0-1.696-.34-2.314-.959-1.276-1.279-1.276-3.349 0-4.628A3.25 3.25 0 0 1 13 9.727c.874 0 1.696.34 2.314.959a3.28 3.28 0 0 1 0 4.628zm-.132-2.678h-1.818v-1.818c0-.201-.163-.364-.364-.364s-.364.163-.364.364v1.818h-1.818c-.201 0-.364.163-.364.364s.163.364.364.364h1.818v1.818c0 .201.163.364.364.364s.364-.163.364-.364v-1.818h1.818c.201 0 .364-.163.364-.364s-.163-.364-.364-.364z'
    />
  </svg>
);

const renderPharmaIcon = (color, width, height) => (
  <svg
    viewBox='2 2 20 20'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform='rotate(45 12 12)'>
      <rect
        x='8'
        y='2'
        rx='4'
        width='8'
        height='20'
        fill={color || '#7b2cbf'}
        fillOpacity='.12'
        stroke={color || '#7b2cbf'}
        strokeWidth='2'
      />
      <path
        d='M8 12h8'
        stroke={color || '#7b2cbf'}
        strokeWidth='2'
      />
    </g>
  </svg>
);

const renderPiggybankIcon = (color, width, height) => (
  <svg
    viewBox='0 0 18 15'
    width={width || 18}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#2073a1'}
      d='M9.153 10.825a.284.284 0 0 0-.287.282v.6c0 .156.129.283.287.283a.284.284 0 0 0 .286-.282v-.601a.284.284 0 0 0-.286-.282zm8.673-4.037a.593.593 0 0 0-.418-.171h-.736c-.01 0-.016-.01-.018-.02a5.952 5.952 0 0 0-1.312-2.659 6.123 6.123 0 0 0-2.35-1.684c-.147-.606-.455-1.231-1.063-1.7a2.803 2.803 0 0 0-1.207-.547.29.29 0 0 0-.228.066.28.28 0 0 0-.1.213v1.522h-1.04A2.12 2.12 0 0 0 7.32.305a2.12 2.12 0 0 0-2.053 1.558 6.115 6.115 0 0 0-3.688 1.915A5.923 5.923 0 0 0 0 7.8c0 3.345 1.767 6.067 2.308 6.822a.902.902 0 0 0 .733.372h1.22a.892.892 0 0 0 .898-.883v-.39a6.24 6.24 0 0 0 .937.071h2.77v.32c0 .486.403.882.898.882h1.34a.9.9 0 0 0 .879-.698l.147-.674a6.073 6.073 0 0 0 4.144-3.437h1.134A.588.588 0 0 0 18 9.604V7.199a.574.574 0 0 0-.174-.411zM7.318.868c.854 0 1.548.683 1.548 1.522 0 .215-.046.426-.135.62H5.905a1.502 1.502 0 0 1-.134-.62c0-.839.694-1.521 1.547-1.521zm10.109 8.736c0 .01-.009.019-.02.019h-.918a5.9 5.9 0 0 0 .28-1.507.284.284 0 0 0-.272-.296.285.285 0 0 0-.3.267c-.122 2.301-1.716 4.266-3.932 4.916l.4-1.837a.282.282 0 0 0-.22-.335.287.287 0 0 0-.34.217l-.683 3.131a.325.325 0 0 1-.318.253h-1.34a.322.322 0 0 1-.325-.32V12.91a.284.284 0 0 0-.286-.282.284.284 0 0 0-.287.282v.32h-2.77c-.315 0-.629-.027-.937-.079v-2.044a.284.284 0 0 0-.286-.282.284.284 0 0 0-.287.282v3.005c0 .177-.146.32-.325.32h-1.22a.32.32 0 0 1-.264-.134C2.26 13.578.573 10.98.573 7.801c0-1.35.508-2.645 1.43-3.645a5.538 5.538 0 0 1 3.195-1.713 2.09 2.09 0 0 0 .095.567h-.115a.284.284 0 0 0-.286.282c0 .156.128.282.286.282h4.28a.284.284 0 0 0 .287-.282.284.284 0 0 0-.286-.282h-.115c.063-.2.095-.409.095-.62v-.018h.956v.62c0 .155.128.281.287.281a.284.284 0 0 0 .286-.282V.656c.544.203 1.567.824 1.567 2.636 0 .156.128.282.287.282a.284.284 0 0 0 .286-.282l-.014-.376a5.548 5.548 0 0 1 1.81 1.386 5.39 5.39 0 0 1 1.188 2.408c.057.273.3.47.58.47h.736c.019.012.019.017.019.019v2.405zM14.925 6.8a1.248 1.248 0 0 0-1.172-.784c-.523 0-.994.315-1.172.784a.28.28 0 0 0 .169.363.288.288 0 0 0 .368-.166.673.673 0 0 1 .635-.417.67.67 0 0 1 .634.417.287.287 0 0 0 .37.166.28.28 0 0 0 .168-.363zm-7.32.786v-1.44c.562.067.956.323.956.556 0 .155.128.281.286.281a.284.284 0 0 0 .287-.281c0-.576-.652-1.04-1.529-1.123v-.033a.284.284 0 0 0-.287-.281.284.284 0 0 0-.286.281v.033c-.877.083-1.529.547-1.529 1.123 0 .822.827 1.12 1.529 1.313v1.44c-.562-.067-.956-.323-.956-.556a.284.284 0 0 0-.286-.281.284.284 0 0 0-.287.281c0 .577.652 1.04 1.529 1.123v.033c0 .155.128.282.286.282a.284.284 0 0 0 .287-.282v-.033c.877-.083 1.529-.546 1.529-1.123 0-.822-.827-1.12-1.529-1.313zm-.573-.16c-.706-.218-.956-.416-.956-.724 0-.233.394-.49.956-.556v1.28zm.573 2.03v-1.28c.706.217.956.415.956.724 0 .232-.394.488-.956.555z'
    />
  </svg>
);

const renderPrintDocumentsIcon = (color, width, height) => (
  <svg
    viewBox='0 0 12 15'
    width={width || 12}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'} >
      <path d='M2.079 6.568c-.397 0-.397.621 0 .621h4.746c.398 0 .398-.62 0-.62H2.08zM6.825 8.037H2.08c-.397 0-.397.62 0 .62h4.746c.398 0 .398-.62 0-.62zM6.825 9.398H2.08c-.397 0-.397.62 0 .62h4.746c.398 0 .398-.62 0-.62zM6.825 10.867H2.08c-.397 0-.397.62 0 .62h4.746c.398 0 .398-.62 0-.62zM6.734 12.253H1.987c-.397 0-.397.62 0 .62h4.747c.397 0 .397-.62 0-.62z' />
      <path d='M.021 3.39v11.587h8.862v-9.98L7.237 3.39zm8.096 10.816H.787V4.162h6.055v1.224h1.275v8.82z' />
      <path d='M2.286 2.956v-.57H8.34V3.61h1.275v8.82h-.337v.772h1.103v-9.98L8.735 1.615H1.52v1.34z' />
      <path d='M3.094 1.341h.766v-.57h6.055v1.224h1.275v8.82h-.337v.772h1.103v-9.98L10.31 0H3.094z' />
    </g>
  </svg>
);

const renderPrintIcon = (color, width, height) => (
  <svg
    viewBox='0 0 17 16'
    width={width || 17}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M15.772 2.45h-3.168V.424c0-.225-.16-.408-.36-.408H4.722c-.198 0-.36.183-.36.408V2.45H1.196C.536 2.45 0 3.058 0 3.805v6.491c0 .747.536 1.355 1.195 1.355h3.168v3.925c0 .225.16.408.36.408h7.521c.2 0 .36-.183.36-.408v-3.925h3.168c.659 0 1.195-.608 1.195-1.355V3.805c0-.747-.536-1.355-1.195-1.355zm-3.168.815h.858v1.142h-.858V3.265zM5.082.832h6.803v3.575H5.082V.832zM3.504 3.265h.859v1.142h-.859V3.265zm8.38 11.903H5.083v-5.37h6.803v5.37zm4.363-4.872c0 .297-.213.54-.475.54h-3.168V9.797h.656c.2 0 .36-.182.36-.407s-.16-.408-.36-.408H3.706c-.198 0-.36.182-.36.408s.162.407.36.407h.657v1.037H1.195c-.262 0-.475-.242-.475-.539v-6.49c0-.298.213-.54.475-.54h1.59v1.55c0 .225.161.407.36.407h10.677c.199 0 .36-.182.36-.408V3.265h1.59c.262 0 .475.242.475.54v6.491z' />
      <circle cx='2.28' cy='6.62' r='1' />
      <path d='M8.379 12.9h-1.68c-.198 0-.36.182-.36.408s.162.407.36.407h1.68c.199 0 .36-.182.36-.407s-.161-.408-.36-.408zm1.888-2.065H6.7c-.2 0-.36.183-.36.408s.16.408.36.408h3.567c.199 0 .36-.183.36-.408s-.161-.408-.36-.408z' />
    </g>
  </svg >
);

const renderPrintIconSmall = (color, width, height) => (
  <svg
    viewBox='0 0 11 11'
    width={width || 11}
    height={height || 11}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#2073a1'}
      d='M10.997 5.027a.227.227 0 0 0-.012-.06c-.003-.007-.004-.014-.008-.022a.22.22 0 0 0-.044-.065L9.625 3.572v-1.28l-.003-.015a.236.236 0 0 0-.012-.059l-.007-.021a.228.228 0 0 0-.045-.067L7.495.067a.227.227 0 0 0-.067-.045l-.02-.007a.229.229 0 0 0-.061-.012L1.604 0a.23.23 0 0 0-.229.23v3.342L.067 4.88a.225.225 0 0 0-.044.065c-.004.008-.005.015-.008.022a.218.218 0 0 0-.012.06L0 5.042v4.354a.23.23 0 0 0 .23.229h1.145v1.146a.23.23 0 0 0 .23.229h7.79a.23.23 0 0 0 .23-.23V9.626h1.146a.23.23 0 0 0 .229-.23V5.043l-.003-.015zm-.78-.215h-.592V4.22l.593.593zm-1.374-2.75h-1.28V.782l1.28 1.28zM1.833.458h5.271v1.834a.23.23 0 0 0 .23.229h1.833v2.292H1.833V.457zM1.375 4.22v.593H.782l.593-.593zm7.792 6.322H1.833v-.917h7.334v.917zm1.375-1.375H.458V5.27h10.084v3.896zM4.183 6.123a.646.646 0 0 0-.251-.134 1.02 1.02 0 0 0-.273-.039h-.763v2.758h.46V7.602h.326c.097 0 .19-.017.281-.05a.665.665 0 0 0 .242-.157.787.787 0 0 0 .17-.263.97.97 0 0 0 .064-.368.926.926 0 0 0-.073-.39.731.731 0 0 0-.183-.25zm-.294.982a.348.348 0 0 1-.269.115h-.265v-.876h.265c.11 0 .2.033.27.1s.104.176.104.324-.035.26-.105.337zM7.04 8.708h.472V7.524h.705v-.401h-.709V6.37h.768v-.42H7.04zM5.517 5.95h-.693v2.758h.69c.355 0 .625-.12.808-.36s.275-.579.275-1.015-.092-.776-.275-1.019-.451-.364-.805-.364zm.567 1.806a.937.937 0 0 1-.126.302.512.512 0 0 1-.44.242h-.222V6.36h.222a.512.512 0 0 1 .44.24.93.93 0 0 1 .126.305c.03.122.045.264.045.428a1.77 1.77 0 0 1-.045.423z'
    />
  </svg>
);

const renderRecordingIconFullRed = (color, width, height, bgColor) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 40}
    height={height || 40}
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cy='20'
      ry='20'
      cx='19.839'
      rx='19.839'
      fill={bgColor || '#930000'}
    />
    <path
      fill={color || '#fff'}
      d='M25.524 23.16a.704.704 0 0 0-.979.053 6.202 6.202 0 0 1-4.57 2.004c-1.741 0-3.407-.73-4.572-2.004a.704.704 0 0 0-.978-.054.667.667 0 0 0-.055.957 7.594 7.594 0 0 0 4.911 2.424v2.77h-1.578a.686.686 0 0 0-.693.679c0 .374.31.678.693.678h4.542a.686.686 0 0 0 .693-.678.686.686 0 0 0-.693-.678h-1.578v-2.77a7.594 7.594 0 0 0 4.911-2.425.667.667 0 0 0-.054-.957zm-5.55-13.827c-2.732 0-4.955 2.101-4.955 4.683v4.288c0 2.582 2.223 4.683 4.955 4.683s4.955-2.101 4.955-4.683v-4.288c0-2.582-2.223-4.683-4.955-4.683zm3.508 8.97c0 1.829-1.574 3.316-3.508 3.316-1.686 0-3.097-1.13-3.432-2.631h1.761c.4 0 .724-.306.724-.684s-.324-.684-.724-.684h-1.836v-.776h1.836c.4 0 .724-.306.724-.684s-.324-.684-.724-.684h-1.836V14.7h1.836c.4 0 .724-.306.724-.684s-.324-.684-.724-.684h-1.76c.334-1.5 1.745-2.63 3.431-2.63 1.934 0 3.508 1.486 3.508 3.314v4.288z'
    />
  </svg>
);

const renderRecordingMicrophone = (
  color,
  width,
  height,
  bgColor,
  innerStroke,
  insertStroke,
) => (
  <svg
    viewBox='0 0 70 70'
    width={width || 70}
    height={height || 70}
    xmlns='http://www.w3.org/2000/svg'
  >
    <defs>
      <circle
        r='24.991'
        cx='24.991'
        cy='24.991'
        id='renderRecordingMicrophone'
      />
    </defs>
    <g
      fill='none'
      fillRule='evenodd'
      transform='translate(10 10)'
    >
      <mask
        fill='#fff'
        id='recordingMicrophoneMask'
      >
        <use xlinkHref='#recordingMicrophone' />
      </mask>
      <use
        fill={bgColor || '#930000'}
        xlinkHref='#renderRecordingMicrophone'
      />
      <circle
        r='29.991'
        cx='24.991'
        cy='24.991'
        strokewidth={width || 10}
        strokeOpacity='.132'
        stroke={innerStroke || '#000'}
      />
      <use
        strokeWidth='3'
        stroke={insertStroke || '#fff'}
        xlinkHref='#recordingMicrophone'
      />
      <circle
        cx='25'
        cy='25'
        r='42.416'
        opacity='.05'
        stroke={insertStroke || '#fff'}
        mask='url(#recordingMicrophoneMask)'
      />
      <g
        fillRule='nonzero'
        fill={color || '#fff'}
        mask='url(#recordingMicrophoneMask)'
      >
        <path d='M31.036 28.047a.742.742 0 0 0-1.03.056 6.533 6.533 0 0 1-4.816 2.111 6.534 6.534 0 0 1-4.814-2.11.742.742 0 0 0-1.031-.057.703.703 0 0 0-.058 1.008 8 8 0 0 0 5.173 2.554v2.918h-1.662c-.403 0-.73.32-.73.714 0 .394.327.714.73.714h4.784c.403 0 .73-.32.73-.714a.722.722 0 0 0-.73-.714H25.92v-2.918a8 8 0 0 0 5.174-2.554.703.703 0 0 0-.058-1.008z' />
        <path d='M25.19 13.483c-2.878 0-5.219 2.213-5.219 4.933v4.516c0 2.72 2.341 4.933 5.22 4.933 2.877 0 5.219-2.213 5.219-4.932v-4.517c0-2.72-2.342-4.933-5.22-4.933zm3.695 9.45c0 1.925-1.658 3.491-3.695 3.491-1.776 0-3.262-1.19-3.615-2.771h1.855c.421 0 .763-.323.763-.72 0-.398-.342-.721-.763-.721h-1.934v-.817h1.934c.421 0 .763-.323.763-.72 0-.399-.342-.721-.763-.721h-1.934v-.818h1.934c.421 0 .763-.322.763-.72 0-.398-.342-.72-.763-.72h-1.855c.353-1.582 1.84-2.772 3.615-2.772 2.037 0 3.695 1.566 3.695 3.492v4.516z' />
      </g>
    </g>
  </svg>
);

const renderSendMessageIcon = (color, width, height) => (
  <svg
    viewBox='0 0 22 20'
    width={width || 22}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#910c00'}
      d='M21.396.08a.32.32 0 0 0-.348-.05L.186 9.77a.323.323 0 0 0-.006.583l5.904 2.912a.32.32 0 0 0 .334-.032l5.74-4.31-4.506 4.657a.324.324 0 0 0-.09.25l.449 5.872a.323.323 0 0 0 .32.298.32.32 0 0 0 .243-.112l3.134-3.649 3.874 1.86a.32.32 0 0 0 .445-.195L21.491.42a.324.324 0 0 0-.095-.34z'
    />
  </svg>
);

const renderSendMessageIconFullRed = (color, width, height, bgColor) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 40}
    height={height || 40}
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cy='20'
      ry='20'
      cx='19.839'
      rx='19.839'
      fill={bgColor || '#930000'}
    />
    <path
      fill={color || '#fff'}
      d='M27.612 11.462l-16.146 7.035 6.963 2.192 2.402 7.18 6.781-16.407zm1.675-2.129c.189 0 .31.077.364.23s.026.362-.081.626l-8.235 19.914c-.08.195-.175.338-.282.428a.525.525 0 0 1-.343.136.6.6 0 0 1-.333-.115.916.916 0 0 1-.293-.345l-2.624-8.433-7.972-2.567c-.323-.209-.474-.442-.454-.7s.205-.462.555-.615l19.254-8.454a1.059 1.059 0 0 1 .444-.104z'
    />
  </svg>
);

const renderSendRecording = (
  color,
  width,
  height,
  bgColor,
  strokeColor,
) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 40}
    height={height || 40}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={bgColor || '#1d9206'}>
      <circle
        cx='20'
        cy='20'
        r='17.5'
        strokeWidth='5'
        strokeOpacity='.3'
        stroke={strokeColor || '#fff'}
      />
      <path
        fill={color || '#fff'}
        d='M25.735 14.287l-11.396 5.975c-.468.246-.45.606.043.801l1.455.575c.49.194 1.235.089 1.652-.238l6.318-4.982c.416-.327.46-.279.1.108l-4.996 5.348c-.362.385-.254.857.238 1.049l.17.066 1.787.711 1.614.657.891.368c.008.013.124-.403.262-.914l2.46-9.042c.14-.51-.13-.727-.598-.482zm-6.772 9.242l-1.116-.457c-.49-.2-.724.035-.521.524l1.008 2.585c-.03.087.994-1.482.994-1.482.29-.443.125-.97-.365-1.17z'
      />
    </g>
  </svg>
);

const renderSettingWithPlusIcon = (color, width, height) => (
  <svg
    viewBox='0 0 18 16'
    width={width || 18}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#707070'}
      d='M13.797 10.04c.036-.1.155-.184.211-.184h.737c.692 0 1.255-.563 1.255-1.255V7.398c0-.692-.563-1.254-1.255-1.254h-.737c-.056 0-.175-.085-.21-.185a6.087 6.087 0 0 0-.258-.617c-.046-.094-.022-.236.018-.275l.524-.524c.489-.49.489-1.285 0-1.774l-.85-.85a1.247 1.247 0 0 0-.888-.368 1.24 1.24 0 0 0-.887.368l-.524.523c-.016.017-.073.043-.153.043a.29.29 0 0 1-.122-.024 6.09 6.09 0 0 0-.617-.258c-.1-.036-.185-.155-.185-.211v-.737C9.856.563 9.293 0 8.601 0H7.4c-.692 0-1.255.563-1.255 1.255v.737c0 .056-.084.175-.185.21a6.11 6.11 0 0 0-.617.259.293.293 0 0 1-.122.024c-.08 0-.136-.026-.152-.043l-.524-.523a1.247 1.247 0 0 0-.888-.368 1.24 1.24 0 0 0-.887.368l-.85.85c-.49.49-.49 1.285 0 1.775l.523.523c.04.04.064.181.019.275a6.11 6.11 0 0 0-.258.617c-.036.1-.155.185-.211.185h-.737C.563 6.144 0 6.707 0 7.399V8.6c0 .692.563 1.255 1.255 1.255h.737c.056 0 .175.085.21.185a6.14 6.14 0 0 0 .258.617c.046.094.022.235-.017.275l-.524.524a1.247 1.247 0 0 0-.368.887c0 .335.13.65.368.888l.85.85c.237.237.552.367.887.367s.65-.13.887-.367l.524-.524c.017-.017.073-.043.153-.043a.29.29 0 0 1 .122.024 5.79 5.79 0 0 0 .617.258c.1.036.185.155.185.211v.737c0 .692.563 1.255 1.255 1.255H8.6c.692 0 1.255-.563 1.255-1.255v-.737c0-.056.085-.175.185-.21.208-.074.416-.161.617-.258a.29.29 0 0 1 .122-.025c.08 0 .136.027.153.043l.524.524c.237.237.552.367.887.367s.65-.13.887-.367l.85-.85c.49-.49.49-1.286 0-1.775l-.523-.524c-.04-.04-.064-.18-.018-.275a6.09 6.09 0 0 0 .257-.617zM11 8c0 1.654-1.346 3-3 3S5 9.654 5 8s1.346-3 3-3 3 1.346 3 3z'
    />
    <circle
      r='4.5'
      cx='13.5'
      cy='11.5'
      fill='#fff'
    />
    <path
      fill={color || '#707070'}
      d='M16.683 8.318A4.474 4.474 0 0 0 13.5 7a4.474 4.474 0 0 0-3.183 1.318 4.504 4.504 0 0 0 0 6.364A4.47 4.47 0 0 0 13.5 16a4.474 4.474 0 0 0 3.183-1.318 4.504 4.504 0 0 0 0-6.364zm-.578 5.785a3.66 3.66 0 0 1-2.605 1.079 3.66 3.66 0 0 1-2.605-1.079 3.685 3.685 0 0 1 0-5.206A3.66 3.66 0 0 1 13.5 7.818a3.66 3.66 0 0 1 2.605 1.079 3.685 3.685 0 0 1 0 5.206zm-.462-2.96h-1.786V9.357a.357.357 0 0 0-.714 0v1.786h-1.786a.357.357 0 0 0 0 .714h1.786v1.786a.357.357 0 0 0 .714 0v-1.786h1.786a.357.357 0 0 0 0-.714z'
    />
  </svg>
);

const renderSimpleRightArrowIcon = (color, width, height) => (
  <svg
    viewBox='0 0 11 8'
    width={width || 11}
    height={height || 8}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M10.85 3.618L7.577.158a.49.49 0 0 0-.723 0c-.2.211-.2.553 0 .764l2.4 2.537H.511C.229 3.459 0 3.701 0 4s.229.541.511.541h8.742l-2.4 2.537c-.2.211-.2.553 0 .764.1.105.231.158.362.158s.262-.053.362-.158l3.273-3.459c.2-.211.2-.553 0-.764z'
    />
  </svg>
);

const renderTapaIcon = (color, width, height) => (
  <svg
    viewBox='2 2 20 20'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#1976c9'}
      d='M12 2L4.5 5v6.3c0 4.65 3.15 8.45 7.5 10.7 4.35-2.25 7.5-6.05 7.5-10.7V5L12 2z'
    />
    <path
      fill='#fff'
      d='M12 6.4l1.7 3.44 3.8.55-2.75 2.68.65 3.78-3.4-1.79-3.4 1.79.65-3.78-2.75-2.68 3.8-.55L12 6.4z'
    />
  </svg>
);

const renderTruckloadIcon = (color, width, height) => (
  <svg
    viewBox='0 0 42 15'
    width={width || 42}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#707070'}>
      <path d='M0 0h28v11H0z' />
      <circle r='1.75' cx='4.25' cy='13.25' />
      <circle r='1.75' cx='9.25' cy='13.25' />
      <circle r='1.75' cx='20.25' cy='13.25' />
      <circle r='1.75' cx='25.25' cy='13.25' />
      <circle r='1.75' cx='38.05' cy='13.25' />
      <path d='M.416 11.532h1.932c-.254.33-.436.629-.546.898s-.178.625-.203 1.068H.416v-1.966zm10.364-.072c.049-.173 1.349.01 1.838.613.326.402.454.879.385 1.43h-1.398c.01-.236-.043-.54-.158-.91-.171-.557-.717-.96-.668-1.133zm11.086.023h1.649l-.482.947c-.096.258-.22.916-.343.897s-.197-.509-.38-.897l-.444-.947zm6.865-9.033c1.64.014 2.817.126 3.53.333s1.394.662 2.045 1.362h-2.33v6.764H28.73v-8.46zm3.639 2.544h3.83l.787.985h-.578l.957 1.874c1.104-.145 1.952.023 2.545.505s.919 1.267.978 2.357c.563.4.778.652.646.758s-.768.133-1.907.083c-.97-.77-1.919-.913-2.844-.43s-1.313 1.36-1.165 2.634H32.37V4.994zM5.866 11.483h1.649l-.482.947c-.096.258-.22.916-.343.897s-.197-.509-.38-.897l-.444-.947zm10.24 2.028h1.45a2.27 2.27 0 0 1 .086-1.044c.161-.47.694-.874.576-.993s-1.129-.05-1.648.439c-.347.326-.501.858-.464 1.598zm23.851-1.141h1.698v1.32H40.16a2.13 2.13 0 0 0 0-.66 2.436 2.436 0 0 0-.203-.66zm-13.075-.865h5.068v1.802h-4.343a3.778 3.778 0 0 0-.23-1.003 2.886 2.886 0 0 0-.495-.799z' />
    </g>
    <path fill='#fff' d='M33.818 5.97h1.494l1.147 1.949h-2.64z' />

  </svg>
);

const renderUpArrowIcon = (
  color,
  width,
  height,
  bgColor,
  stroke,
) => (
  <svg
    viewBox='0 0 18 18'
    width={width || 18}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='8'
      cx='9'
      cy='9'
      stroke={stroke}
      fill={bgColor || '#d8d8d8'}
    />
    <path
      fill={color || '#353535'}
      d='M11.874 9.177L9.53 6.193c-.088-.124-.232-.197-.384-.193a.53.53 0 0 0-.385.16L6.129 9.145c-.192.225-.16.545.032.706.225.192.546.16.706-.032L8.6 7.86v4.59c0 .288.225.513.514.513.137.002.268-.052.365-.149s.15-.228.148-.365V7.958l1.476 1.829a.5.5 0 0 0 .385.192.62.62 0 0 0 .321-.096c.225-.193.257-.513.065-.706z'
    />
  </svg>
);

const renderUpArrowIconBig = (
  color,
  width,
  height,
  bgColor,
  stroke,
) => (
  <svg
    viewBox='0 0 32 32'
    width={width || 32}
    height={height || 32}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='15'
      cx='16'
      cy='16'
      fill={bgColor || '#fff'}
      stroke={stroke || '#353535'}
    />
    <path
      fill={color || '#930000'}
      d='M21.388 16.332l-4.392-5.596a.86.86 0 0 0-.722-.361 1 1 0 0 0-.723.3l-4.933 5.597c-.361.42-.301 1.023.06 1.323.42.361 1.023.301 1.323-.06l3.25-3.67v8.604a.95.95 0 0 0 .962.963.95.95 0 0 0 .963-.963v-8.424l2.768 3.43a.94.94 0 0 0 .722.361c.18 0 .421-.06.602-.18.42-.361.481-.963.12-1.324z'
    />
  </svg>
);

const renderUpArrowSimpleIcon = (color) => (
  <svg
    width={12}
    height={14}
    viewBox='0 0 12 14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#2073a1'}
      d='M11.388 6.332L6.996.736a.858.858 0 0 0-.722-.361 1 1 0 0 0-.723.3L.618 6.273c-.361.42-.301 1.023.06 1.323.42.361 1.023.301 1.323-.06l3.25-3.67v8.604a.95.95 0 0 0 .962.963.95.95 0 0 0 .963-.963V4.045l2.768 3.43a.94.94 0 0 0 .722.361c.18 0 .421-.06.602-.18.42-.361.481-.963.12-1.324z'
    />
  </svg>
);

const renderUpArrowWithSettingIcon = (
  color,
  width,
  height,
  bgColor,
  stroke,
  subColor,
) => (
  <svg
    viewBox='0 0 18 17'
    width={width || 18}
    height={height || 17}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={bgColor || '#d8d8d8'}>
      <circle
        r='8'
        cx='8'
        cy='8'
        stroke={stroke}
        fill={bgColor || '#d8d8d8'}
      />
      <circle
        cx='14'
        cy='13'
        r='1.333'
      />
    </g>
    <path
      fill={color || '#353535'}
      d='M10.874 8.177L8.53 5.193A.457.457 0 0 0 8.146 5a.531.531 0 0 0-.385.16L5.129 8.145c-.192.225-.16.545.032.706.225.192.546.16.706-.032L7.6 6.86v4.59c0 .288.225.513.514.513a.507.507 0 0 0 .513-.514V6.958l1.476 1.829a.502.502 0 0 0 .385.192.62.62 0 0 0 .321-.096c.225-.193.257-.513.065-.706z'
    />
    <path
      fill={subColor || '#ce2828'}
      d='M16.899 13.02c.018-.05.077-.092.105-.092h.369a.628.628 0 0 0 .627-.627v-.602a.628.628 0 0 0-.627-.627h-.369c-.028 0-.087-.042-.105-.093a3.044 3.044 0 0 0-.13-.308c-.022-.047-.01-.118.01-.137l.262-.262a.628.628 0 0 0 0-.888l-.425-.425a.623.623 0 0 0-.888 0l-.262.262c-.008.008-.036.021-.076.021a.145.145 0 0 1-.061-.012 3.045 3.045 0 0 0-.308-.129c-.05-.017-.093-.077-.093-.105v-.369A.628.628 0 0 0 14.301 8h-.602a.628.628 0 0 0-.627.627v.369c0 .028-.042.087-.092.105-.105.037-.209.08-.309.13a.146.146 0 0 1-.06.011c-.041 0-.07-.013-.077-.02l-.262-.263a.623.623 0 0 0-.887 0l-.426.425a.628.628 0 0 0 0 .888l.262.262c.02.02.032.09.01.137-.05.1-.093.204-.13.309-.018.05-.077.092-.105.092h-.369a.628.628 0 0 0-.627.627v.602a.63.63 0 0 0 .627.627h.369c.028 0 .087.042.105.093.037.104.08.208.13.308.022.047.01.118-.01.137l-.262.262a.623.623 0 0 0 0 .888l.425.425a.623.623 0 0 0 .888 0l.262-.262c.008-.008.036-.021.076-.021.023 0 .045.004.061.012.1.048.204.092.309.129.05.017.092.077.092.105v.369a.63.63 0 0 0 .627.627h.602a.628.628 0 0 0 .627-.627v-.369c0-.028.042-.087.092-.105a2.77 2.77 0 0 0 .309-.13.145.145 0 0 1 .06-.011c.041 0 .07.013.077.02l.262.263a.623.623 0 0 0 .888 0l.425-.425a.628.628 0 0 0 0-.888l-.262-.261c-.02-.02-.032-.09-.01-.138.05-.1.093-.204.13-.309zM15.222 12c0 .674-.548 1.222-1.222 1.222A1.224 1.224 0 0 1 12.778 12c0-.674.548-1.222 1.222-1.222s1.222.548 1.222 1.222z'
    />
  </svg>
);

const reportPending = (color, width, height) => (
  <svg
    viewBox='0 0 40 40'
    width={width || 18}
    height={height || 18}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.327 32.547H4.57a4.57 4.57 0 0 1-3.23-1.34A4.57 4.57 0 0 1 0 27.977V11.739A2.68 2.68 0 0 1 2.676 9.06l2.68.004h.004V3.221A2.68 2.68 0 0 1 8.037.547l24.442.004a2.68 2.68 0 0 1 2.674 2.672v18.205a9.95 9.95 0 0 0-2.197-.984V3.225a.48.48 0 0 0-.479-.481H8.037a.48.48 0 0 0-.479.479v22.313a1.65 1.65 0 0 1-1.65 1.567 1.65 1.65 0 0 1-1.65-1.567V11.26H2.676l.002-.002a.48.48 0 0 0-.481.481V27.98c0 1.307 1.063 2.373 2.373 2.373h15.436a9.98 9.98 0 0 0 .321 2.195zm.998-7.525h-9.929a1.1 1.1 0 0 1-1.099-1.098 1.1 1.1 0 0 1 1.099-1.099h11.639a10.04 10.04 0 0 0-1.709 2.197zm7.647-15.887l-14.061-.004a1.1 1.1 0 0 1-1.098-1.099 1.1 1.1 0 0 1 1.098-1.099l14.061.004a1.1 1.1 0 0 1 1.099 1.099 1.1 1.1 0 0 1-1.099 1.099zm-.002 5.295H11.398a1.1 1.1 0 0 1-1.099-1.098 1.1 1.1 0 0 1 1.099-1.098H28.97a1.1 1.1 0 0 1 1.098 1.098 1.1 1.1 0 0 1-1.098 1.098zm0 5.295H11.396a1.1 1.1 0 0 1-1.099-1.098 1.1 1.1 0 0 1 1.099-1.099h17.576a1.1 1.1 0 0 1 1.097 1.1 1.1 1.1 0 0 1-1.1 1.097zm5.776 12.381h-2.718a.6.6 0 1 0 0 1.2h1.44A4.8 4.8 0 0 1 25.2 30a.6.6 0 1 0-1.2 0 6 6 0 0 0 10.128 4.338V35.4a.6.6 0 1 0 1.2 0v-2.7a.6.6 0 0 0-.582-.594zM30 24a6 6 0 0 0-4.128 1.662V24.6a.6.6 0 1 0-1.2 0v2.7a.6.6 0 0 0 .6.6h2.7a.6.6 0 1 0 0-1.2h-1.44A4.8 4.8 0 0 1 34.8 30a.6.6 0 1 0 1.2 0 6 6 0 0 0-6-6z'
      fill={color || '#fff'}
    />
    <circle
      r='9'
      cx='30'
      cy='30'
      fill='none'
      strokeWidth='2'
      stroke={color || '#fff'}
    />
  </svg>
);

const rolesList = (color, width, height) => (
  <svg
    viewBox='0 0 20 21'
    width={width || 20}
    height={height || 21}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M4.831 17.147H2.23a.75.75 0 0 1-.588-.276c-.146-.178-.203-.41-.156-.636.763-3.624 3.997-6.271 7.731-6.357.062.002.125.004.187.004s.126-.002.189-.004c.913.021 1.805.19 2.654.506.38.141.803-.049.946-.425s-.05-.795-.43-.936a9.55 9.55 0 0 0-.367-.128c1.216-.902 2.004-2.339 2.004-3.954C14.4 2.216 12.159 0 9.404 0S4.408 2.216 4.408 4.941c0 1.617.79 3.055 2.007 3.957a9.58 9.58 0 0 0-3.079 1.673C1.657 11.937.489 13.843.048 15.938a2.19 2.19 0 0 0 .454 1.849c.425.516 1.054.813 1.728.813h2.601a.73.73 0 0 0 .735-.727.73.73 0 0 0-.735-.727zM5.878 4.941c0-1.923 1.582-3.487 3.527-3.487s3.527 1.564 3.527 3.488c0 1.866-1.49 3.394-3.355 3.483l-.172-.002-.172.002c-1.865-.089-3.354-1.617-3.354-3.483z' />
      <g transform='matrix(.838671 -.544639 .544639 .838671 5.841362 17.271783)'>
        <path d='M12.648 1.144C12.339.451 11.644.002 10.874 0H8.625c-.816 0-1.524.48-1.809 1.223l-.133.369H1.96a.72.72 0 0 0-.518.22L.204 3.092c-.273.282-.272.731.003 1.011l1.262 1.288a.72.72 0 0 0 .514.216h2.344c.398 0 .721-.324.721-.724s-.323-.724-.721-.724H2.286l-.556-.568.536-.554h4.959a.72.72 0 0 0 .701-.552c.058-.239.132-.469.237-.745.07-.182.245-.295.46-.295h2.251c.204 0 .38.11.458.287.194.435.425 1.107.427 1.845.002.743-.229 1.431-.423 1.878-.078.18-.255.296-.453.296H8.603c-.2 0-.386-.129-.465-.32a4.82 4.82 0 0 1-.223-.716.72.72 0 0 0-.869-.535c-.387.093-.626.484-.534.872.084.351.18.656.293.931.303.737 1.008 1.214 1.797 1.216h2.277c.775 0 1.471-.457 1.778-1.165.249-.574.546-1.466.544-2.459s-.302-1.869-.552-2.432z' />
        <circle r='1' cx='10.5' cy='3.9' />
      </g>
    </g>
  </svg>
);

const routeBuilder = (color, width, height) => (
  <svg
    viewBox='0 0 16 15'
    width={width || 16}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M3.773 7.65h7.76c1.713 0 3.104-1.344 3.104-2.994s-1.394-2.994-3.104-2.994h-7.57C3.773.545 2.689-.197 1.571.046.57.262-.109 1.22.014 2.235a2 2 0 0 0 2.315 1.73 2 2 0 0 0 1.637-1.637h7.571c1.344 0 2.438 1.044 2.438 2.328s-1.094 2.328-2.438 2.328H3.773C2.06 6.985.666 8.329.666 9.979s1.394 2.994 3.104 2.994h5.405L7.752 14.4a.33.33 0 0 0-.007.469c.13.13.339.136.469.007l1.999-1.999a.33.33 0 0 0 0-.469L8.22 10.412c-.133-.126-.343-.123-.469.007s-.123.333 0 .462l1.427 1.427H3.773c-1.347 0-2.442-1.044-2.442-2.328s1.095-2.33 2.442-2.33zM1.997 3.323a1.33 1.33 0 1 1 0-2.661 1.33 1.33 0 1 1 0 2.661zm11.642 7.339a2 2 0 0 0-1.996 1.996 2 2 0 0 0 1.996 1.996 2 2 0 0 0 1.996-1.996c0-1.101-.891-1.993-1.996-1.996zm0 3.326a1.33 1.33 0 1 1 0-2.661 1.33 1.33 0 1 1 0 2.661z' />
      <path d='M7.41 5.24a1.82 1.82 0 0 0-.459-1.767 1.79 1.79 0 0 0-1.742-.465l1.018 1.025-.267 1.003-.998.269L3.943 4.28c-.162.605-.008 1.277.465 1.753a1.79 1.79 0 0 0 1.831.44l.006.006 4.188 4.215c.166.166.383.251.6.251s.434-.084.6-.251a.86.86 0 0 0 0-1.208L7.41 5.24zm3.696 5.311c-.178 0-.322-.146-.322-.326s.144-.326.322-.326.326.146.326.326-.146.326-.326.326z' />
    </g>
  </svg>
);

const routeBuilder2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M6.057.782a.49.49 0 0 0-.235.235c-.074.142-.066.276.03.536l.082.252c0 .016-.407.027-1.099.027l-1.37.041C2.182 2.067 1.097 3.063.749 4.37a3.58 3.58 0 0 0-.055 1.31c.233 1.331 1.37 2.46 2.743 2.72.142.027.711.036 2.442.036h2.256l.008-1.088.005-1.086h-2.13c-1.477 0-2.177-.008-2.278-.03-.347-.074-.651-.312-.798-.626-.079-.164-.085-.2-.085-.465 0-.279.003-.298.101-.498.15-.304.388-.495.719-.58.134-.036.353-.044 1.222-.044l1.061.011a8.08 8.08 0 0 1-.096.273c-.052.144-.096.314-.096.375 0 .293.293.533.582.479a1.59 1.59 0 0 0 .336-.17 22.18 22.18 0 0 1 2.51-1.354l.615-.314c.219-.172.224-.528.014-.727-.044-.041-.252-.15-.462-.243-.809-.364-1.892-.941-2.598-1.386-.29-.186-.342-.208-.479-.216a.43.43 0 0 0-.232.036zm6.111.667c-.61.096-1.094.541-1.247 1.148-.066.257-.041.634.055.891a1.61 1.61 0 0 0 .919.897 2.01 2.01 0 0 0 .891.03c.276-.079.479-.2.681-.407.602-.613.599-1.515-.011-2.125a1.31 1.31 0 0 0-.386-.29 1.63 1.63 0 0 0-.902-.145zM9.16 7.328v1.094h.692c.727 0 .85.016 1.083.134a1.2 1.2 0 0 1 .476.517c.082.17.087.205.087.47s-.005.298-.087.468c-.161.328-.487.569-.848.626a7.69 7.69 0 0 1-.779.027H9.16v1.097 1.099l.829-.016c.878-.016 1.028-.035 1.427-.169 1.52-.509 2.513-2.138 2.242-3.683-.232-1.334-1.392-2.475-2.759-2.715-.178-.03-.437-.041-.99-.041H9.16V7.33zm-7.894 2.94c-.662.145-1.184.796-1.184 1.476a1.54 1.54 0 0 0 1.509 1.518c.424 0 .774-.145 1.072-.443.607-.61.61-1.539.005-2.141a1.5 1.5 0 0 0-1.403-.41zm2.786 1.482l.008 1.088h2.037 2.037l.008-1.088.005-1.085H6.098 4.047l.005 1.085z'
    />
    <defs>
      <clipPath>
        <path d='M0 0h14v14H0z' />
      </clipPath>
    </defs>
  </svg>
);

const routeTemplates = (color, width, height) => (
  <svg
    viewBox='0 0 16 15'
    width={width || 16}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M3.773 7.671h7.76c1.714 0 3.104-1.343 3.104-2.993s-1.393-2.994-3.103-2.994H3.963A1.996 1.996 0 0 0 1.57.067 2.002 2.002 0 0 0 .014 2.256a2 2 0 0 0 2.316 1.73 2 2 0 0 0 1.636-1.637h7.571c1.344 0 2.438 1.045 2.438 2.329s-1.094 2.328-2.438 2.328H3.773C2.06 7.006.666 8.35.666 10s1.394 2.994 3.104 2.994h5.405L7.752 14.42a.328.328 0 0 0-.007.469c.13.13.34.136.469.006l.007-.006 1.992-1.993a.33.33 0 0 0 0-.469l-1.992-1.996a.334.334 0 0 0-.47.007.336.336 0 0 0 0 .462l1.428 1.427H3.773c-1.347 0-2.441-1.044-2.441-2.328S2.426 7.67 3.773 7.67zM1.997 3.344a1.33 1.33 0 1 1 0-2.66 1.33 1.33 0 0 1 0 2.66zm11.643 7.318a1.997 1.997 0 0 0-1.997 1.996 2 2 0 0 0 1.996 1.996 1.997 1.997 0 0 0 1.996-1.996 1.997 1.997 0 0 0-1.996-1.996zm0 3.326a1.33 1.33 0 1 1-.001-2.66 1.33 1.33 0 0 1 0 2.66z'
    />
  </svg>
);

const routesLoads = (color, width, height) => (
  <svg
    viewBox='0 0 16 15'
    width={width || 16}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M3.773 7.671h7.76c1.714 0 3.104-1.343 3.104-2.993s-1.393-2.994-3.103-2.994H3.963A1.996 1.996 0 0 0 1.57.067 2.002 2.002 0 0 0 .014 2.256a2 2 0 0 0 2.316 1.73 2 2 0 0 0 1.636-1.637h7.571c1.344 0 2.438 1.045 2.438 2.329s-1.094 2.328-2.438 2.328H3.773C2.06 7.006.666 8.35.666 10s1.394 2.994 3.104 2.994h5.405L7.752 14.42a.328.328 0 0 0-.007.469c.13.13.34.136.469.006l.007-.006 1.992-1.993a.33.33 0 0 0 0-.469l-1.992-1.996a.334.334 0 0 0-.47.007.336.336 0 0 0 0 .462l1.428 1.427H3.773c-1.347 0-2.441-1.044-2.441-2.328S2.426 7.67 3.773 7.67zM1.997 3.344a1.33 1.33 0 1 1 0-2.66 1.33 1.33 0 0 1 0 2.66zm11.643 7.318a1.997 1.997 0 0 0-1.997 1.996 2 2 0 0 0 1.996 1.996 1.997 1.997 0 0 0 1.996-1.996 1.997 1.997 0 0 0-1.996-1.996zm0 3.326a1.33 1.33 0 1 1-.001-2.66 1.33 1.33 0 0 1 0 2.66z'
    />
  </svg>
);

const routesLoads2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M1.572.246C.984.399.489.796.232 1.323c-.238.481-.219.104-.219 4.528l.167 4.689a4.6 4.6 0 0 0 2.929 3.046c.544.178.755.208 1.444.208.591-.003.648-.005.957-.079 1.69-.396 2.975-1.627 3.418-3.27.145-.541.15-.673.15-3.339s-.008-2.529.15-2.677c.06-.057.101-.068.232-.068.167 0 .257.052.336.191.025.041.036 1.042.046 3.828l.014 3.773.085.241c.249.695.788 1.19 1.485 1.362.331.085.826.066 1.138-.041.328-.112.571-.268.834-.533a1.59 1.59 0 0 0 .364-.495c.243-.489.221-.101.232-4.375l-.022-4.061A4.55 4.55 0 0 0 11.02.457c-.47-.175-.85-.243-1.411-.26-.555-.014-.818.014-1.28.129C6.792.714 5.543 1.928 5.1 3.459c-.164.569-.159.459-.175 3.309l-.049 2.68c-.112.197-.353.263-.528.145-.208-.139-.191.175-.191-3.91l-.15-4.208A2.13 2.13 0 0 0 2.551.235a2.56 2.56 0 0 0-.979.011zM2.3 1.922c.178.118.189.167.189.965 0 .695-.003.716-.06.804-.101.148-.197.202-.347.202-.104 0-.156-.016-.235-.077-.17-.129-.178-.178-.178-.952 0-.621.005-.703.052-.788.112-.213.386-.287.58-.156zm8.064.077c.536.175 1.173.637 1.209.872.046.323-.243.577-.536.465-.038-.014-.15-.093-.252-.175a2.26 2.26 0 0 0-.684-.386.93.93 0 0 1-.26-.139.4.4 0 0 1 .09-.648c.12-.06.224-.057.432.011zm-1.827.107c.186.052.312.279.268.481-.03.126-.129.23-.325.336-.216.118-.443.304-.596.489-.161.2-.246.252-.399.257-.306.005-.503-.284-.38-.561.104-.235.618-.714.962-.897.254-.137.314-.148.47-.107zm3.566 2.04c.049.025.12.09.153.145.06.096.063.126.071.798.011.788.003.837-.172.971-.079.06-.131.077-.235.077-.15 0-.246-.055-.344-.202-.06-.087-.063-.107-.063-.837V4.35l.088-.101c.049-.055.112-.109.142-.12.093-.038.262-.03.361.016zm-4.864.443c.161.115.172.175.172.938 0 .643-.003.7-.057.807a.44.44 0 0 1-.353.23.48.48 0 0 1-.353-.219c-.057-.104-.06-.126-.052-.839.008-.705.011-.736.068-.818.129-.178.399-.224.574-.098zM2.3 4.903c.178.118.189.167.189.965 0 .695-.003.716-.06.804-.101.148-.197.202-.347.202-.104 0-.156-.016-.235-.077-.17-.129-.178-.178-.178-.952 0-.621.005-.703.052-.788.112-.213.386-.287.58-.156zm9.841 2.239c.181.126.191.172.191.946s-.008.823-.178.952c-.079.06-.131.077-.235.077-.15 0-.246-.055-.344-.202-.06-.088-.063-.109-.063-.804 0-.626.006-.725.049-.809a.41.41 0 0 1 .58-.159zm-4.903.427c.161.115.172.175.172.938 0 .643-.003.7-.057.807a.44.44 0 0 1-.353.23.48.48 0 0 1-.353-.219c-.057-.104-.06-.126-.052-.839.008-.705.011-.736.068-.818.129-.178.399-.224.574-.098zM2.3 7.883c.18.118.189.167.189.971 0 .637-.005.73-.046.804-.156.26-.55.257-.705-.005-.049-.088-.055-.148-.063-.807-.008-.654-.003-.719.044-.807a.41.41 0 0 1 .582-.156zm9.841 2.239c.181.126.191.172.191.946s-.008.823-.178.952c-.079.06-.131.077-.235.077-.15 0-.246-.055-.344-.202-.06-.088-.063-.109-.063-.804 0-.626.006-.725.049-.809a.41.41 0 0 1 .58-.159zm-5.452.284c.164.079.252.29.2.481-.022.088-.09.175-.306.391-.552.55-1.039.768-1.277.572a.4.4 0 0 1 0-.651c.049-.038.098-.071.115-.071.077 0 .503-.323.656-.495.096-.107.202-.21.241-.23.093-.052.26-.049.372.003zm-3.73.232c.03.016.142.101.246.189.191.161.451.312.692.397.227.082.342.221.342.41 0 .2-.131.358-.334.407-.09.022-.386-.068-.637-.197-.44-.219-.842-.566-.878-.755a.46.46 0 0 1 .178-.418c.101-.068.293-.085.391-.033z'
    />
    <defs>
      <clipPath>
        <path d='M0 0h14v14H0z' />
      </clipPath>
    </defs>
  </svg>
);

const routesLoads3 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M11.312.027a2.34 2.34 0 0 0-1.958 2.045 1.97 1.97 0 0 0 0 .44c.049.399.298 1.014.686 1.693.331.58.544.911 1.08 1.662l.254.358v.29c0 .284.003.295.079.38a.21.21 0 0 0 .208.09c.11 0 .139-.014.208-.09.077-.085.079-.096.079-.375v-.287l.213-.295C13.368 4.279 14 3.016 14 2.275a2.49 2.49 0 0 0-.394-1.233 2.83 2.83 0 0 0-.681-.67c-.462-.295-1.094-.429-1.613-.345zm.582 1.78a.46.46 0 0 1 .29.284.52.52 0 0 1 .014.465.57.57 0 0 1-.67.336c-.189-.041-.38-.232-.421-.421-.104-.476.356-.861.788-.664zm-8.982 2.91c-.766.142-1.384.459-1.9.976C.208 6.497-.15 7.705.068 8.859c.202 1.05.883 2.327 1.95 3.65a20.6 20.6 0 0 0 1.132 1.263c.241.232.273.241.725.213.317-.019.323-.022.413-.112s.093-.107.079-.205c-.008-.071-.044-.142-.09-.191l-.074-.077.167-.178c.391-.418 1.025-1.222 1.362-1.725 1.296-1.933 1.583-3.494.9-4.897-.495-1.014-1.4-1.682-2.57-1.887-.268-.046-.886-.046-1.148.003zM3.91 6.47c.479.112.93.47 1.146.913.148.301.205.571.186.875-.044.673-.427 1.228-1.039 1.504-.235.104-.432.145-.703.145-.932 0-1.682-.708-1.742-1.649-.019-.304.038-.574.186-.875.213-.437.664-.801 1.132-.913a2.25 2.25 0 0 1 .834 0zm7.369 1.192c-.03.016-.118.096-.191.172-.159.164-.328.238-.692.301-.202.036-.249.052-.312.123-.085.093-.098.205-.038.323s.15.153.366.134c.498-.041.913-.238 1.159-.547.159-.202.137-.396-.06-.498-.093-.049-.159-.052-.232-.008zm-2.351.746c-.287.142-.612.511-.823.932-.12.235-.126.257-.093.35.041.129.145.208.271.208.145 0 .2-.052.35-.32.126-.23.328-.462.618-.708.082-.071.101-.104.101-.189 0-.246-.208-.38-.424-.273zm-1.296 2.166a1.05 1.05 0 0 0-.18.323l-.276.596c-.197.394-.213.489-.107.615.156.186.355.131.511-.139.243-.418.514-1.053.514-1.198 0-.077-.019-.123-.085-.186-.112-.115-.262-.118-.377-.011zM6.15 12.731c-.273.183-.454.276-.76.394-.241.093-.331.183-.331.328a.31.31 0 0 0 .197.268c.265.071 1.348-.484 1.457-.746a.29.29 0 0 0-.263-.397c-.041 0-.17.066-.301.153z'
    />
  </svg>
);

const rotateLeft = (color, width, height) => (
  <svg
    version='1.1'
    width={width || 16}
    viewBox='0 0 16 16'
    height={height || 16}
    fill={color || '#000'}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <path
      fill={color || '#000'}
      d='M8 0c-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.5-1.5c1-2 3.1-3.5 5.5-3.5 3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-0.8-4.5-2.1l-1.5 1.3c1.4 1.7 3.6 2.8 6 2.8 4.4 0 8-3.6 8-8s-3.6-8-8-8z'
    />
  </svg>
);

const rotateRight = (color, width, height) => (
  <svg
    version='1.1'
    width={width || 16}
    viewBox='0 0 16 16'
    height={height || 16}
    fill={color || '#000'}
    xmlns='http://www.w3.org/2000/svg'
    style={{ transform: 'rotateY(180deg)' }}
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <path
      fill={color || '#000'}
      d='M8 0c-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.5-1.5c1-2 3.1-3.5 5.5-3.5 3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-0.8-4.5-2.1l-1.5 1.3c1.4 1.7 3.6 2.8 6 2.8 4.4 0 8-3.6 8-8s-3.6-8-8-8z'
    />
  </svg>
);

export {
  radio,
  remove,
  refresh,
  rolesList,
  rotateLeft,
  rotateRight,
  routesLoads,
  reloadCircle,
  routeBuilder,
  routesLoads2,
  routesLoads3,
  renderHotIcon,
  reportPending,
  routeBuilder2,
  renderChatIcon,
  renderClipIcon,
  renderColdIcon,
  renderEditIcon,
  renderFileIcon,
  renderMailIcon,
  renderTapaIcon,
  routeTemplates,
  renderEventIcon,
  renderPrintIcon,
  renderDriverIcon,
  renderPharmaIcon,
  renderAddFileIcon,
  renderCirclesIcon,
  renderDrayageIcon,
  renderUpArrowIcon,
  renderCallCheckIcon,
  renderDownArrowIcon,
  renderHazardousIcon,
  renderInfoAlertIcon,
  renderItemIconSmall,
  renderPiggybankIcon,
  renderSendRecording,
  renderTruckloadIcon,
  renderTeamDriverIcon,
  renderDetailInfoIcon,
  renderPauseRecording,
  renderPrintIconSmall,
  renderUpArrowIconBig,
  renderActionsMenuIcon,
  renderCancelRecording,
  renderSendMessageIcon,
  renderAuditHistoryIcon,
  renderHighSecurityIcon,
  renderDownArrowIconBig,
  renderUpArrowSimpleIcon,
  renderPrintDocumentsIcon,
  renderDownArrowSimpleIcon,
  renderRecordingMicrophone,
  renderSettingWithPlusIcon,
  renderPickDropWithPlusIcon,
  renderRecordingIconFullRed,
  renderSimpleRightArrowIcon,
  renderSendMessageIconFullRed,
  renderUpArrowWithSettingIcon,
  renderDownArrowWithSettingIcon,
};
